const items = [
  "Master Parquet Work",
  "Luxury LVT",
  "Precision Subfloor Prep",
  "Bespoke Residential & Commercial",
  "Dustless Refinishing",
  "Heritage Restoration",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-border bg-secondary/60 py-5 select-none"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground"
              >
                <span className="px-8">{item}</span>
                <span className="w-1.5 h-1.5 rotate-45 bg-primary/60 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
